import store from '../store'
import {flatMap, map, flatten, find, some, match, intersection} from 'lodash'

const funcs = {
  checkPermission(permissions) {
    let isLoggedIn = store.state.isLoggedIn

    if (!isLoggedIn) return false
    if (permissions == null || permissions.length == 0) return true

    let user = store.state.currentUser
    let userPermissions = flatten(map(flatMap(user.roleNames), m => m.permissions))

    return intersection(userPermissions, permissions).length > 0
  },
}

export default funcs



// WEBPACK FOOTER //
// ./src/shared/permission.js